// extracted by mini-css-extract-plugin
module.exports = {"chapter":"resourcelist_chapter__3NYIv"};